import { ClickFormsAdjustmentGridFieldsMap } from '../../types.ts';

export const FNMA1025_FORM_CODE = 'F349';
export const FNMA1025_TOTAL_ROWS = 883;
export const FNMA1025_SALES_COMP_GRID_ROWS_PER_COMP = 82;

export const FNMA1025_ADJUSTMENT_FIELDS: ClickFormsAdjustmentGridFieldsMap = {
  salePrice: 531,
  saleFinanceAdj: 543,
  concAdj: 545,
  dateOfSaleAdj: 547,
  locationAdj: 549,
  propRightsAdj: 551,
  siteAdj: 553,
  viewAdj: 555,
  designAdj: 557,
  qualityAdj: 559,
  actualAgeAdj: 561,
  conditionAdj: 563,
  gbaAdj: 565,
  unitBreakdownAdj: 566,
  unit1Adj: 570,
  unit2Adj: 574,
  unit3Adj: 578,
  unit4Adj: 582,
  basementLine1Adj: 584,
  basementLine2Adj: 586,
  funcUtilAdj: 588,
  heatingCoolingAdj: 590,
  energyEffAdj: 592,
  garageCarportAdj: 594,
  porchPatioAdj: 596,
  blank1Adj: 598,
  blank2Adj: 600,
  blank3Adj: 602,
};

export const FNMA1025_ROWS = {
  SU_BLANK1_LABEL: 522,
  SU_BLANK2_LABEL: 524,

  // COST APPROACH
  CA_SUPPORT_FOR_SITE_VALUE: 826,
  CA_REPRODUCTION_CHECKBOX: 827,
  CA_REPLACEMENT_COST_NEW_CHECKBOX: 828,
  CA_COST_DATA_SOURCE: 829,
  CA_QUALITY: 830,
  CA_EFFECTIVE_DATE: 831,
  CA_COMMENTS: 832,
  CA_ESTIMATED_REMAINING_ECON_LIFE: 833,
  CA_OPINION_OF_SITE_VALUE: 834,
  CA_DWELLING_SQFT: 835,
  CA_DWELLING_COST_PER_SQFT: 836,
  CA_DWELLING_COST: 837,
  CA_OTHER1_LABEL: 838,
  CA_OTHER1_SQFT: 839,
  CA_OTHER1_COST_PER_SQFT: 840,
  CA_OTHER1_COST: 841,
  CA_OTHER2: 842,
  CA_OTHER2_COST: 843,
  CA_GARAGE_CARPORT_SQFT: 844,
  CA_GARAGE_CARPORT_COST_PER_SQFT: 845,
  CA_GARAGE_CARPORT_COST: 846,
  CA_TOTAL_ESTIMATE_OF_COST_NEW: 847,
  CA_DEPR_PHYS: 849,
  CA_DEPR_FUNC: 851,
  CA_DEPR_EXTN: 853,
  CA_DEPR_TOTAL: 854,
  CA_DEPR_COST_OF_IMPROVEMENTS: 855,
  CA_AS_IS_SITE_IMPROVEMENTS: 856,
  CA_INDICATED_VALUE: 857,
  CA_EFFECTIVE_AGE: 142,
};
